/**
 * Base entity models for cms-post-lib
 * 
 * @remarks
 * These base interfaces provide common fields and patterns used across
 * all CMS domain entities. Use composition to build specific models.
 */

/**
 * Base entity interface - all resources extend this
 * 
 * @remarks
 * Every entity has these core fields for tracking creation and modification.
 */
export interface BaseEntity {
  /**
   * Unique identifier (MongoDB ObjectId as string)
   */
  _id: string;

  /**
   * ISO 8601 timestamp of when the entity was created
   */
  createdAt: string;

  /**
   * ISO 8601 timestamp of when the entity was last updated
   */
  updatedAt: string;
}

/**
 * Entity with soft delete capability
 * 
 * @remarks
 * Entities extending this can be marked as deleted without removal from database.
 */
export interface SoftDeletableEntity extends BaseEntity {
  /**
   * Whether the entity has been soft deleted
   */
  isDeleted: boolean;

  /**
   * ISO 8601 timestamp of when the entity was deleted
   * Only present if isDeleted is true
   */
  deletedAt?: string;
}

/**
 * Entity with active/inactive status
 * 
 * @remarks
 * Entities can be enabled or disabled without deletion.
 */
export interface ActivatableEntity extends BaseEntity {
  /**
   * Whether the entity is currently active
   */
  isActive: boolean;
}
